/* Scoped enhancement for the Joliemap shell/home; catalogue/cart behavior stays in Debut. */
(() => {
  'use strict';
  function mount(root = document) {
    root.querySelectorAll('[data-jm-header]').forEach(header => {
      if (header.dataset.jmMounted) return;
      header.dataset.jmMounted = 'true';
      const button = header.querySelector('.jm-menu-toggle');
      const nav = header.querySelector('#mobile-nav');
      if (!button || !nav) return;
      function closeMenu() { nav.hidden = true; button.setAttribute('aria-expanded', 'false'); }
      button.addEventListener('click', () => { const opening = nav.hidden; nav.hidden = !opening; button.setAttribute('aria-expanded', String(opening)); });
      nav.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
      header.addEventListener('keydown', event => { if (event.key === 'Escape' && !nav.hidden) { closeMenu(); button.focus(); } });
      const media = window.matchMedia('(min-width: 681px)');
      media.addEventListener('change', event => { if (event.matches) closeMenu(); });
    });
    root.querySelectorAll('[data-jm-home]').forEach(home => {
      if (home.dataset.jmMounted) return;
      home.dataset.jmMounted = 'true';
      const choices = Array.from(home.querySelectorAll('.jm-style-choice'));
      const names = Object.fromEntries(choices.map(button => [button.dataset.style, button.textContent.trim()]));
      const images = Array.from(home.querySelectorAll('.jm-poster img'));
      const source = Object.fromEntries(images.map(img => [img.getAttribute('src').match(/hero-(mondrian|moutarde|nationale6)\.png/)[1], img.getAttribute('src')]));
      const dimensions = {mondrian:[1143,1600], moutarde:[1715,2400], nationale6:[1201,1600]};
      function updatePoster(poster, style) {
        if (!poster || !source[style]) return;
        poster.src = source[style];
        poster.alt = 'Carte de Venise dans le style ' + names[style];
        [poster.width, poster.height] = dimensions[style];
      }
      choices.forEach(button => button.addEventListener('click', () => {
        const style = button.dataset.style;
        const background = choices.map(choice => choice.dataset.style).filter(value => value !== style);
        updatePoster(home.querySelector('#main-poster'), style);
        updatePoster(home.querySelector('.jm-poster-left img'), background[0]);
        updatePoster(home.querySelector('.jm-poster-right img'), background[1]);
        choices.forEach(choice => { const selected = choice === button; choice.classList.toggle('jm-selected', selected); choice.setAttribute('aria-pressed', String(selected)); });
        home.querySelector('#style-status').textContent = 'Style ' + names[style] + ' affiché';
      }));
    });
    root.querySelectorAll('[data-open-faq]').forEach(link => {
      if (link.dataset.jmMounted) return;
      link.dataset.jmMounted = 'true';
      link.addEventListener('click', () => {
        const match = Array.from(document.querySelectorAll('.jm-faq-list details')).find(details => details.querySelector('summary').textContent === link.dataset.openFaq);
        if (match) match.open = true;
      });
    });
    if (location.hash === '#faq-livraison') {
      const details = document.getElementById('faq-livraison');
      if (details) details.open = true;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount());
  else mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
